export const filterData = (data, lower, filterKeys) => {
  return data.filter((item) => {
    if (!lower) {
      return true;
    }
    return filterKeys.some((key) => {
      const itemValue = item[key];
      return itemValue && itemValue.toLowerCase().includes(lower.toLowerCase());
    });
  });
};
